import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRolesEnum } from '@collections/users/enums';
import { Observable } from 'rxjs';
import { IPortalEvent } from '@collections/portal-events/interfaces/portal-events.interface';
import { SoftDeletePortalEventGQL } from 'app/shared/services/portal-events/graphql/portal-event-delete.gql.service';
import { CardEditBarComponent } from '../../../../shared/components/card-edit-bar/card-edit-bar.component';
import { RenderIfDirective } from '../../../../shared/directives/render-if.directive';
import { EventBlockComponent } from '../../../../portal-events/views/event-block/event-block.component';
import { BlockHorizontalScrollerComponent } from '../../../../shared/components/block-horizontal-scroller/block-horizontal-scroller.component';
import { FullHeaderSliderComponent } from '../../../../layout/components/full-header-slider/full-header-slider.component';

@Component({
    selector: 'events-archive-header',
    templateUrl: './events-archive-header.component.html',
    styleUrls: ['./events-archive-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FullHeaderSliderComponent, BlockHorizontalScrollerComponent, EventBlockComponent, RenderIfDirective, CardEditBarComponent]
})
export class EventsArchiveHeaderComponent implements OnInit {

  UserRolesEnum = UserRolesEnum;
  portalEvent$: Observable<IPortalEvent>;
  isFirstLoad = true;
  nextPortalEvent = [];
  minDate = new Date(-8640000000000000);
  constructor(
    private softDeletePortalEventGQL: SoftDeletePortalEventGQL,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {

  }

  addEvent(): void {
    this.router.navigate(['../', 'events', 'edit', ''], { relativeTo: this.activatedRoute });
  }

  editEvent(event): void {
    this.router.navigate(['../', 'events', 'edit', event._id], { relativeTo: this.activatedRoute });
  }

  softDeletePortalEvent(event): void {
    this.softDeletePortalEventGQL.mutate({
      id: event._id
    })
    .subscribe();
  }
}
